// extracted by mini-css-extract-plugin
module.exports = {"block":"Radio_block__FYGLW","root":"Radio_root__dah6o","error":"Radio_error__1ZmdZ","label":"Radio_label__2vLWJ","description":"Radio_description__1khpj"};